module.exports = __webpack_public_path__ + "img/character-10.29df339f.svg";